var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashCan = function SvgTrashCan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "trash-can_svg__path-1",
    d: "M2 21.34C2 22.802 3.2 24 4.667 24h10.666A2.67 2.67 0 0 0 18 21.34V6H2zM20 2h-5l-1.674-2H6.674L5 2H0v2h20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-can_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-can_svg__icons-badges-variations",
    transform: "translate(-125 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash-can_svg__icons/trash-can",
    transform: "translate(125 237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "trash-can_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash-can_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash-can_svg__path-1",
    id: "trash-can_svg__Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash-can_svg__color/black-tint/0-000000",
    fill: "#000",
    fillRule: "evenodd",
    mask: "url(#trash-can_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "trash-can_svg__gray-70-4A4A4A",
    d: "M0 0h20v25H0z",
    transform: "translate(0 -1)"
  })))))));
};
export default SvgTrashCan;